var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgAccountSettings = function SvgAccountSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.78 2a1 1 0 0 0-.97.76L9.4 4.43a8 8 0 0 0-2.63 1.53L5.1 5.48a1 1 0 0 0-1.14.46L2.73 8.06a1 1 0 0 0 .17 1.21l1.24 1.2a8.04 8.04 0 0 0 0 3.05l-1.24 1.2a1 1 0 0 0-.17 1.22l1.22 2.12a1 1 0 0 0 1.14.46l1.67-.48a8 8 0 0 0 2.63 1.53l.42 1.67a1 1 0 0 0 .97.76h2.44a1 1 0 0 0 .97-.76l.42-1.68a8 8 0 0 0 2.63-1.52l1.67.48a1 1 0 0 0 1.14-.46l1.22-2.12a1 1 0 0 0-.17-1.21l-1.24-1.2a8.04 8.04 0 0 0 0-3.05l1.24-1.2a1 1 0 0 0 .17-1.22l-1.22-2.12a1 1 0 0 0-1.14-.46l-1.67.48a8 8 0 0 0-2.63-1.53l-.42-1.67a1 1 0 0 0-.97-.76h-2.44Zm6.37 6.91a6 6 0 0 0-10.3 0l-.1.2a5.97 5.97 0 0 0 0 5.78l.1.2c.15.24.31.47.49.69a6.97 6.97 0 0 1 9.32 0c.18-.22.34-.45.49-.7l.1-.17a5.97 5.97 0 0 0 0-5.81l-.1-.19Z"
  })));
};

export default SvgAccountSettings;